"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Card_styles_1 = require("./Card.styles");
var PriceBreakDown_1 = __importDefault(require("./PriceBreakDown"));
var formatAndDropDecimal_1 = __importDefault(require("../../../utils/formatAndDropDecimal"));
var TileDataContext_1 = require("../../TileDataContext");
var NonAuthPayOnce = function () {
    var _a = (0, TileDataContext_1.useTileDataContext)(), _b = _a.tileData, transportCost = _b.transportCost, _c = _b.price, total = _c.total, totalDiscountAmount = _c.totalDiscountAmount, _d = _a.financeInfo, price = _d.price, tradeInApplied = _d.tradeInApplied;
    var _e = price !== null && price !== void 0 ? price : {}, downPaymentDetails = _e.downPaymentDetails, estimatedTaxesAndFees = _e.estimatedTaxesAndFees, _f = _e.totalTaxes, totalTaxes = _f === void 0 ? 0 : _f, _g = _e.feesMinusShipping, feesMinusShipping = _g === void 0 ? 0 : _g;
    var _h = downPaymentDetails !== null && downPaymentDetails !== void 0 ? downPaymentDetails : {}, _j = _h.nonRefundableShippingFees, nonRefundableShippingFees = _j === void 0 ? 0 : _j, _k = _h.tradeDown, tradeDown = _k === void 0 ? 0 : _k;
    var showNSFVerbiage = transportCost !== 0 && transportCost === nonRefundableShippingFees;
    var fees = estimatedTaxesAndFees !== null && estimatedTaxesAndFees !== void 0 ? estimatedTaxesAndFees : feesMinusShipping + totalTaxes;
    var tradeValue = tradeInApplied ? tradeDown : 0;
    var totalPurchasePrice = total - tradeValue + transportCost + fees;
    return (react_1.default.createElement(Card_styles_1.Card, null,
        react_1.default.createElement(Card_styles_1.TitleWrapper, null,
            react_1.default.createElement(Card_styles_1.Title, null, "Pay Once"),
            react_1.default.createElement(Card_styles_1.Price, null,
                "$",
                (0, formatAndDropDecimal_1.default)(totalPurchasePrice))),
        react_1.default.createElement(Card_styles_1.GreyBar, null),
        react_1.default.createElement(PriceBreakDown_1.default, { appliedTrade: tradeInApplied, showNSFVerbiage: showNSFVerbiage, taxTitleReg: fees, total: total, totalDiscount: totalDiscountAmount, transportCost: transportCost, tradeDown: tradeValue, card: "once" }),
        react_1.default.createElement(Card_styles_1.GreyListSection, null,
            react_1.default.createElement(Card_styles_1.LineItem, null,
                react_1.default.createElement(Card_styles_1.Title, null, "Total Purchase Price "),
                react_1.default.createElement("span", { className: "t-header-xs" },
                    "$",
                    (0, formatAndDropDecimal_1.default)(totalPurchasePrice))),
            transportCost > 0 && showNSFVerbiage && (react_1.default.createElement(Card_styles_1.LineItem, null,
                react_1.default.createElement("span", { className: "text-grey-5" },
                    "Includes $",
                    transportCost,
                    " nonrefundable shipping fee"))))));
};
exports.default = NonAuthPayOnce;
//# sourceMappingURL=NonAuthPayOnce.js.map